import bus from '@/utils/eventBus'
import { isMobile } from 'mobile-device-detect'

import { get } from 'lodash'

const dtToday = () => {
  let isNow = new Date()
  let month = isNow.getMonth() + 1
  let day = isNow.getDate()
  let today = isNow.getFullYear() + '-' + (('' + month).length < 2 ? '0' : '') + month + '-' + (('' + day).length < 2 ? '0' : '') + day
  return today
}

export default function () {
  /** vericando se existe avatar e se seria obrigatorio */
  if (this.user.image_required === 'true') {
    if (this.user.image_id === null) {
      if (this.$route.name !== 'dweller.profile.me.me') {
        this.$toast.error('Você precisa definir uma foto no seu perfil.')
        return this.$router.push({name: 'dweller.profile.me.me'})
      }
    }
  }

  if (get(this.$route, 'params.id', null) !== null) {
    // this.selectEvents(get(this.$route, 'params.id', null))
    this.area_id = get(this.$route, 'params.id', null)
    Promise.all([
      this.getCommonArea(),
      this.getTowersDweller(),
      this.getDwellerGuestList()
    ])
  } else {
    Promise.all([
      this.getCommonArea(),
      this.getTowersDweller(),
      this.getDwellerGuestList()
    ])
  }
  bus.$on('on-uploaded-avatar', values => {
    this.onUploadedAvatar(values.response)
  })

  bus.$on('do-loading', values => {
    this.loading = values.show
  })

  bus.$on('get-events-common-area', values => {
    Promise.all([
      this.setCommomAreaId(values.id),
      this.getCommonAreaById(values.id)
    ])
  })
  bus.$on('do-delete-schedule', values => {
    this.loading = values.status
    this.area_id = null
    this.id_common_area = null
    this.scheduleTimes = []
    this.minDt = dtToday()
    this.schedule = {
      id: null,
      event_name: null,
      title: null,
      start_date: null,
      end_date: null,
      tower_id: null,
      unit_id: null,
      dweller_guest_list_id: null,
      common_area_id: null,
      go_in: null,
      go_out: null
    }
    this.prevRestart()
  })
  bus.$on('exist-events-common-area', values => {
    if (values.status) {
      this.isScheduled = true
    }
    if (!values.status) {
      this.isScheduled = false
    }
  })

  if (isMobile) {
    this.isMobiled = true
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/resources/mounted.js